module.exports = __webpack_public_path__ + "static/media/new-home-4083230_640.6a0ab0b2.jpg";